import {
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {  useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import pemdingLeaguesIcon from "../../../styles/images/pendingLeagueIcon.svg";
import activeLeagueIcon from "../../../styles/images/activeLeagueIcon.svg";
import { useParams } from "react-router-dom";
import addSeasonSchema from "../../../schemas/addSeason";
import { getJoinedLeague, getLeagueParticipants, getLeagueSeasons } from "../../../services/leagues";
import SeasonTable from "../../my_leagues/leagueByID/seasonTable";

export default function JoinedLeagueDetail() {
  const [createSeason, setCreateSeason] = useState(false);
  const { id: league_id } = useParams();
  const isPendingLeague = league_id % 2 != 0;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  // const [totalRecords, setTotalRecords] = useState(0);
  const {
    register,
    getValues,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    ...methods
  } = useForm({
    resolver: yupResolver(addSeasonSchema),
    defaultValues: {
      season_name: "",
      weeks_for_season_games: "",
    },
  });

  // Data fetching function
  const fetchData = async () => {
    try {
      setLoading(true);
      console.log("in try === ", league_id);
      const response = await getLeagueSeasons(league_id);

      console.log("response get participants == ", response.data.participants);
      setData(response.data);
      // setTotalRecords(response.data.conducted_leagues.length);
      // setData([
      //   {
      //     id: 1,
      //     player_number: 1,
      //     name: "Player 1",
      //     email: "player1@gmail.com",
      //   },
      //   {
      //     id: 2,
      //     player_number: 2,
      //     name: "Player 2",
      //     email: "player2@gmail.com",
      //   },
      // ]);
    } catch (err) {
      // setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch data when dependencies change
  useEffect(() => {
    fetchData();
  }, []);

  console.log("jooined league data === ", data);

  return (
    <div>
      <div className="league-header">
        <img
          className="league-header-image"
          src={isPendingLeague ? pemdingLeaguesIcon : activeLeagueIcon}
          alt="league"
        />
        <div className="league-header-content">
          <p className="heading-title">{data?.league_name}</p>
          <p>{data?.description}</p>
        </div>
      </div>

      <div>
        <div className="league-header mt-4">
          <div className="league-header-content">
            <p className="heading-title-players">Seasons</p>
          </div>
        </div>
        <SeasonTable refetch={refetch} />
      </div>
    </div>
  );
}
